import ReportService from '_services/rest/modules/report';

export default {
  state: {
    reportFilters: null,
    reportSellerList: null,
    reportProductList: null,
    reportQuotationList: null,
  },
  mutations: {
    setReportFilters(state, response) {
      state.reportFilters = response;
    },
    setReportProductList(state, response) {
      state.reportProductList = response;
    },
    setReportQuotationList(state, response) {
      state.reportQuotationList = response;
    },
    setReportSellerList(state, response) {
      state.reportSellerList = response;
    },
  },
  actions: {
    getReportFilters({ commit }, params) {
      return ReportService.getReportFilters(params)
        .then(response => {
          commit('setReportFilters', response);
          return response;
        });
    },
    getReportProductList({ commit }, params) {
      return ReportService.getReportProductList(params)
        .then(response => {
          commit('setReportProductList', response);
          return response;
        });
    },
    getReportQuotationList({ commit }, params) {
      return ReportService.getReportQuotationList(params)
        .then(response => {
          commit('setReportQuotationList', response);
          return response;
        });
    },
    getReportSellerList({ commit }, params) {
      return ReportService.getReportSellerList(params)
        .then(response => {
          commit('setReportSellerList', response);
          return response;
        });
    },
  },
};
